import { motion } from "framer-motion";
import { useScrollCtx } from "@/providers/AppProviders";

export const ScrollProgressBar = () => {
  const { progress } = useScrollCtx();
  return (
    <div className="fixed inset-x-0 top-0 z-[70] h-[3px] bg-border/40 pointer-events-none">
      <motion.div
        className="h-full origin-left bg-primary"
        style={{ scaleX: progress }}
      />
    </div>
  );
};
